namespace TabAurous.ECommerce {
    export interface ECommOrderItemsForm {
        TransId: Serenity.StringEditor;
        TransItemId: Serenity.StringEditor;
        PartyId: Serenity.IntegerEditor;
        BagNo: Serenity.StringEditor;
        SKU: Serenity.StringEditor;
        RefNo: Serenity.StringEditor;
        ItemTypeId: Serenity.IntegerEditor;
        IsConfigurable: Serenity.BooleanEditor;
        ProductId: Serenity.StringEditor;
        ProductTypeId: Serenity.LookupEditor;
        ProductCode: Serenity.StringEditor;
        ProductName: Serenity.StringEditor;
        AttributeId: Serenity.StringEditor;
        CategoryId: CommonCategoryLookup;
        SubCategoryId: CommonSubCategoryLookup;
        BrandId: Serenity.LookupEditor;
        SuperTypeId: Serenity.LookupEditor;
        CollectionId: Serenity.LookupEditor;
        ProductSizeId: CommonProductSizeLookup;
        HasBom: Serenity.BooleanEditor;
        MetalId: Serenity.LookupEditor;
        Attribute: Serenity.StringEditor;
        KaratId: Serenity.LookupEditor;
        Purity: Serenity.DecimalEditor;
        PureWeight: WeightEditor;
        MetalColorId: Serenity.LookupEditor;
        ShapeId: Serenity.LookupEditor;
        StoneColorId: Serenity.LookupEditor;
        QualityId: Serenity.LookupEditor;
        StoneSizeId: StoneSizeLookup;
        SieveId: StoneSieveLookup;
        GroupSieveId: StoneSieveLookup;
        StoneCutId: Serenity.LookupEditor;
        StonePolishId: Serenity.LookupEditor;
        StoneSymmetryId: Serenity.LookupEditor;
        StoneFluorescenceId: Serenity.LookupEditor;
        StoneCuletId: Serenity.LookupEditor;
        StoneGirdleId: Serenity.LookupEditor;
        StoneTable: Serenity.StringEditor;
        StoneDepth: Serenity.StringEditor;
        LotNo: Serenity.StringEditor;
        Lab: Serenity.LookupEditor;
        CertificateNo: Serenity.StringEditor;
        CalcOnId: Serenity.LookupEditor;
        CalcUnitId: Serenity.LookupEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: WeightEditor;
        UnitRate: Serenity.DecimalEditor;
        UnitLabour: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        GrossAmount: Serenity.DecimalEditor;
        HSN: Serenity.LookupEditor;
        TaxCode: Serenity.LookupEditor;
        NetWeight: WeightEditor;
        DiamondPieces: Serenity.IntegerEditor;
        DiamondWeight: WeightEditor;
        StonePieces: Serenity.IntegerEditor;
        StoneWeight: WeightEditor;
        OtherPieces: Serenity.IntegerEditor;
        OtherWeight: WeightEditor;
        MetalAmount: Serenity.DecimalEditor;
        DiamondAmount: Serenity.DecimalEditor;
        StoneAmount: Serenity.DecimalEditor;
        OtherAmount: Serenity.DecimalEditor;
        UnitCost: Serenity.DecimalEditor;
        Discount: Serenity.DecimalEditor;
        WstPer: Serenity.DecimalEditor;
        WstWt: WeightEditor;
        DepartmentId: Serenity.IntegerEditor;
        Remarks: Serenity.StringEditor;
        IsDisabled: Serenity.BooleanEditor;
        ServerDate: Serenity.DateEditor;
        RefTransItemId: Serenity.StringEditor;
        RefTransId: Serenity.StringEditor;
        Remark: Serenity.StringEditor;
        SpecialRemark: Serenity.StringEditor;
        UserDescription: Serenity.StringEditor;
        AckStatus: Serenity.IntegerEditor;
        DeliveryDate: Serenity.DateEditor;
        CompanyId: Serenity.IntegerEditor;
        BagStatus: Serenity.StringEditor;
        Line_No: Serenity.StringEditor;
        ImageName: Serenity.ImageUploadEditor;
        BOMDetails: OrderBOMEditor;
        LaborDetails: OrderLaborEditor;
    }

    export class ECommOrderItemsForm extends Serenity.PrefixedContext {
        static formKey = 'ECommerce.OrderItems';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ECommOrderItemsForm.init)  {
                ECommOrderItemsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.BooleanEditor;
                var w3 = s.LookupEditor;
                var w4 = CommonCategoryLookup;
                var w5 = CommonSubCategoryLookup;
                var w6 = CommonProductSizeLookup;
                var w7 = s.DecimalEditor;
                var w8 = WeightEditor;
                var w9 = StoneSizeLookup;
                var w10 = StoneSieveLookup;
                var w11 = s.DateEditor;
                var w12 = s.ImageUploadEditor;
                var w13 = OrderBOMEditor;
                var w14 = OrderLaborEditor;

                Q.initFormType(ECommOrderItemsForm, [
                    'TransId', w0,
                    'TransItemId', w0,
                    'PartyId', w1,
                    'BagNo', w0,
                    'SKU', w0,
                    'RefNo', w0,
                    'ItemTypeId', w1,
                    'IsConfigurable', w2,
                    'ProductId', w0,
                    'ProductTypeId', w3,
                    'ProductCode', w0,
                    'ProductName', w0,
                    'AttributeId', w0,
                    'CategoryId', w4,
                    'SubCategoryId', w5,
                    'BrandId', w3,
                    'SuperTypeId', w3,
                    'CollectionId', w3,
                    'ProductSizeId', w6,
                    'HasBom', w2,
                    'MetalId', w3,
                    'Attribute', w0,
                    'KaratId', w3,
                    'Purity', w7,
                    'PureWeight', w8,
                    'MetalColorId', w3,
                    'ShapeId', w3,
                    'StoneColorId', w3,
                    'QualityId', w3,
                    'StoneSizeId', w9,
                    'SieveId', w10,
                    'GroupSieveId', w10,
                    'StoneCutId', w3,
                    'StonePolishId', w3,
                    'StoneSymmetryId', w3,
                    'StoneFluorescenceId', w3,
                    'StoneCuletId', w3,
                    'StoneGirdleId', w3,
                    'StoneTable', w0,
                    'StoneDepth', w0,
                    'LotNo', w0,
                    'Lab', w3,
                    'CertificateNo', w0,
                    'CalcOnId', w3,
                    'CalcUnitId', w3,
                    'Pieces', w1,
                    'Weight', w8,
                    'UnitRate', w7,
                    'UnitLabour', w7,
                    'NetAmount', w7,
                    'GrossAmount', w7,
                    'HSN', w3,
                    'TaxCode', w3,
                    'NetWeight', w8,
                    'DiamondPieces', w1,
                    'DiamondWeight', w8,
                    'StonePieces', w1,
                    'StoneWeight', w8,
                    'OtherPieces', w1,
                    'OtherWeight', w8,
                    'MetalAmount', w7,
                    'DiamondAmount', w7,
                    'StoneAmount', w7,
                    'OtherAmount', w7,
                    'UnitCost', w7,
                    'Discount', w7,
                    'WstPer', w7,
                    'WstWt', w8,
                    'DepartmentId', w1,
                    'Remarks', w0,
                    'IsDisabled', w2,
                    'ServerDate', w11,
                    'RefTransItemId', w0,
                    'RefTransId', w0,
                    'Remark', w0,
                    'SpecialRemark', w0,
                    'UserDescription', w0,
                    'AckStatus', w1,
                    'DeliveryDate', w11,
                    'CompanyId', w1,
                    'BagStatus', w0,
                    'Line_No', w0,
                    'ImageName', w12,
                    'BOMDetails', w13,
                    'LaborDetails', w14
                ]);
            }
        }
    }
}
